<template>
  <div :id="'digital_'+id" class="comp digital-item-comp" @click="onClick">
    <img class="cover-img" v-lazy="cover" />
    <div class="info-wrap">
      <div class="title">{{ title }}</div>
      <!-- <div class="sub-title">{{ sub_title }}</div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'dataItem',
  props: {
    id: {
      type: Number
    },
    title: {
      type: String
    },
    sub_title: {
      type: String
    },
    cover: {
      type: String
    },
    beforeClick: {
			type: Function,
			default: () => { }
		}
  },
  methods: {
    onClick() {
      if (!!this.beforeClick) {
				this.beforeClick();
			}
      this.$router.push({ name: 'digitalGeneral', query: { id: this.id,cover:this.cover} });
    }
  }
};
</script>
<style lang="stylus" scoped>
.digital-item-comp {
  display: inline-block;
  width: 330px;
  height: 336px;
  border-radius: 20px;
  box-shadow: #999 0px 0px 5px;
  overflow : hidden;
  vertical-align:bottom;
  .cover-img {
    display: block;
    width: 100%;
    height: 200px;
  }

  .info-wrap {
    padding 22px 20px;
    .title {
      font-weight: bold;
      font-size: 28px;
      margin-bottom: 20px;
      height: 80px;
      line-height: 40px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .sub-title{
      color: #999;
      overflow hidden
      text-overflow:ellipsis
      white-space nowrap
    }
  }

}
</style>
